// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MultiLanguage from 'vue-multilanguage'
import FlagIcon from 'vue-flag-icon'

import App from './App'
import router from './router'

Vue.config.productionTip = false

Vue.use(MultiLanguage, {
	de: {
		hi: 'Hallo'
	},
	en: {
		hi: 'Hello'
	}
})
Vue.use(FlagIcon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
    currentRoute: window.location.pathname
  },
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js